var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-container"},[_c('v-btn',{attrs:{"color":"primary","large":"","depressed":""},on:{"click":_vm.redirectToOIDC}},[_vm._v(" Connectez-vous via votre compte INSERM ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }